import React, { useContext } from "react";
import { ImageDetailsList, ImageListItem } from "./compare-images/image-details-list";
import { ProductDetails } from "./compare-images/product-details";
import { MatchedProductDetails } from "./compare-images/matched-product-details";
import { TaskContext } from "../../../contexts/task";

export const CompareImages = ({ productShots, reference, matchedProducts, onStepChange, onZoomCompare, imageAttributeGroups, isPhysicalRemote }) => {
    const { task } = useContext(TaskContext);
    const isFinalQa = task.sourcePage === "finalqa";

    return (
        <div className="image-compare">
            <div className="compare-header">
                <button
                    className="button"
                    onClick={() => onStepChange("PRODUCT_MATCH")}
                >
                    Back
                </button>
                <div className="compare-subheader">
                    <h3>Compare Images</h3>
                    <span className="compare-subheader-upc">{task.context.upc}</span>
                </div>
                <button className="button -primary -hidden">Save</button>
            </div>

            <ImageDetailsList className="image-list">
                {productShots && (
                    <ImageListItem className="image-item">
                        <ProductDetails productShots={productShots} />
                    </ImageListItem>
                )}
                {reference && (
                    <ImageListItem className="image-item">
                        <MatchedProductDetails
                            matchedProduct={reference}
                            imageAttributeGroups={imageAttributeGroups}
                            isFinalQa={isFinalQa}
                            isReference={true}
                            isPhysicalRemote={isPhysicalRemote}
                        />
                    </ImageListItem>
                )}
                {matchedProducts.map((matchedProduct, index) => {
                    return (
                        <ImageListItem
                            key={matchedProduct.productId || matchedProduct.codingWipKey}
                            className="image-item"
                        >
                            <MatchedProductDetails
                                onZoomCompare={onZoomCompare}
                                matchedProduct={matchedProduct}
                                productNumber={index + 1}
                                imageAttributeGroups={imageAttributeGroups}
                                isFinalQa={isFinalQa}
                                isPhysicalRemote={isPhysicalRemote}
                            />
                        </ImageListItem>
                    );
                })}
            </ImageDetailsList>
        </div>
    );
};
